import { useEffect, useState } from "react";
import { Store, UsersRound } from "lucide-react";
import { api } from "@/lib/api";

// Publish window: choose the main Marketplace or one of your private groups.
export const PublishDestination = ({ value, onChange }) => {
  const [groups, setGroups] = useState(null);
  useEffect(() => {
    api.get("/groups").then((r) => setGroups(r.data.filter((g) => g.status === "active"))).catch(() => setGroups([]));
  }, []);
  if (!groups) return null;
  const opt = (id, label, Icon, testid) => (
    <button key={testid} type="button" data-testid={testid} onClick={() => onChange(id)}
      className={`shrink-0 h-8 px-3 rounded-full text-xs border flex items-center gap-1.5 transition-colors ${
        value === id ? "bg-[#2563EB] border-[#2563EB] text-white" : "bg-[#1E1E1E] border-[#27272A] text-[#9CA3AF] hover:text-white"}`}>
      <Icon className="h-3 w-3" /> {label}
    </button>
  );
  return (
    <div className="space-y-1.5" data-testid="publish-destination">
      <div className="text-xs text-[#9CA3AF]">Publish to</div>
      <div className="flex flex-wrap gap-1.5">
        {opt(null, "Marketplace", Store, "publish-dest-market")}
        {groups.length ? groups.map((g) => opt(g.group_id, g.name, UsersRound, `publish-dest-${g.group_id}`)) : (
          <button type="button" disabled data-testid="publish-dest-group-disabled"
            className="shrink-0 h-8 px-3 rounded-full text-xs border flex items-center gap-1.5 bg-[#1E1E1E] border-[#27272A] text-[#6B7280] opacity-50 cursor-not-allowed">
            <UsersRound className="h-3 w-3" /> Group
          </button>
        )}
      </div>
      {!groups.length && <p data-testid="publish-dest-no-groups" className="text-[10px] text-[#6B7280]">Create or join a group in Community to publish to a group.</p>}
      {value && <p className="text-[10px] text-[#6B7280]">Only members of this group can see and buy it.</p>}
    </div>
  );
};
